import type { DagTaskStatus } from './constants';

const DAG_TASK_STATUS_VALUES = new Set<DagTaskStatus>([
  'removed',
  'scheduled',
  'queued',
  'running',
  'success',
  'restarting',
  'failed',
  'up_for_retry',
  'up_for_reschedule',
  'upstream_failed',
  'skipped',
  'deferred',
  'none',
]);

export const normalizeDagTaskStatus = (status?: string | null): DagTaskStatus => {
  if (!status) {
    return 'none';
  }

  return DAG_TASK_STATUS_VALUES.has(status as DagTaskStatus) ? (status as DagTaskStatus) : 'none';
};
